import { POINTS_SET, POINTS_TRIGGER_BOUNCE, POINTS_CLEAR_BOUNCE } from '../types/pointsTypes.js';

export const setPoints = (value) => ({ type: POINTS_SET, payload: value });
export const triggerCoinBounce = () => ({ type: POINTS_TRIGGER_BOUNCE });
export const clearCoinBounce = () => ({ type: POINTS_CLEAR_BOUNCE });